import {
  PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN,
  PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR,
  PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER,
} from 'features/auth/permissions/rolodexPermissionsList'

import { PermissionsGate } from '..'
import { DefinedGateProps } from './AssetOverviewGates'

export const ProcessFlowAdminGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const ProcessFlowEditorGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN,
        PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const ProcessFlowViewerGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_PROCESS_FLOW_ADMIN,
        PERMISSION_CANTILEVER_PROCESS_FLOW_EDITOR,
        PERMISSION_CANTILEVER_PROCESS_FLOW_VIEWER,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}
